<template>
  <div class="space-1">
    <div class="row justify-content-lg-between mb-7">
      <div class="col-md-6 col-lg-5">
        <!-- Info -->
        <div class="mb-5 mt-3">
          <h1 class="text-secondary text-center mb-3">We hunted high and low but couldn't find you any deals.</h1>
          <ul v-if="zeroResultsHints().length > 0" class="text-secondary bold">
            <li v-for="hint in zeroResultsHints()" :key="hint">{{ hint }}</li>
          </ul>
        </div>
        <div class="mb-3 text-center">
          <button class="btn btn-sm btn-soft-success w-90" @click="$emit('retry')">Change your search criteria and try again</button>
          <p class="my-3">OR</p>
          <button class="btn btn-sm btn-soft-success w-90" @click="$emit('refine')">Refine your filters</button>
        </div>
        <!-- End Info -->
      </div>

      <div class="col-md-6 d-none d-md-inline-block">
        <figure class="w-80">
          <img class="img-fluid" src="/assets/svg/illustrations/hiker-man.svg" alt="Image Description">
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import {prettyMoney, prettyPercent} from "@/main.ts";

export default {
  name: "ProductNoProductsAvailable",
  
  props: {
    query: Object,
    filters: Object,
    filtersModified: Boolean,
    stats: Object
  },
  
  methods: {
    zeroResultsHints() {
      let hints = [];

      if (this.query.ltv() > this.stats["maxLtv"])
        hints.push("You're LTV (" + prettyPercent(this.query.ltv()) + ") exceeds the maximum available from any lender.");

      if (this.query.isRemortgage() && this.query.remainingBalance > this.query.propertyValue)
        hints.push("You're borrowing amount (" + prettyMoney(this.query.borrowingAmount()) +") is greater than your property value (" + prettyMoney(this.query.propertyValue) +").");

      return hints;
    }
  }
}
</script>

<style scoped>

</style>